module.exports = __webpack_public_path__ + "img/img_deal_bnr_01.ff3d2d6a.png";